import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { BLOCKS, PRESETS } from "@/lib/dashboardBlocks";
import { usePermissions } from "@/context/PermissionsContext";

export function AddBlockDialog({ open, onClose, onAdd }) {
  const { can, hiddenNav } = usePermissions();
  const presets = PRESETS.filter((p) => !p.page || (can(p.page, "view") && !hiddenNav.includes(p.path)));
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-h-[85vh] overflow-y-auto sm:max-w-2xl" data-testid="add-block-dialog">
        <DialogHeader><DialogTitle>Add a block</DialogTitle></DialogHeader>
        <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
          {presets.map((p, i) => {
            const Icon = p.icon || BLOCKS[p.type].icon;
            return (
              <button key={p.label} onClick={() => onAdd(p)} data-testid={`add-block-option-${i}`}
                className="flex items-start gap-3 rounded-xl border border-slate-200 p-3 text-left transition-colors hover:border-sky-300 hover:bg-sky-50/50">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-sky-50"><Icon className="h-4 w-4 text-sky-600" /></span>
                <span className="min-w-0">
                  <span className="block text-sm font-semibold text-slate-800">{p.label}</span>
                  <span className="block text-xs text-slate-400">{p.desc}</span>
                </span>
              </button>
            );
          })}
        </div>
      </DialogContent>
    </Dialog>
  );
}
